import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { HELP_CENTER_ROUTE_PATHS } from './config';

export const ACTION_CONFIG_ROUTES: TApplicationRoute[] = [
  {
    id: 'help-center-action-configs',
    path: HELP_CENTER_ROUTE_PATHS.actionConfigs,
    component: lazy(() => import('./pages/action-configs-page')),
    layout: 'default',
    permissions: { scopes: ['help-center'] },
    menu: {
      title: 'pages.helpCenter.actionConfigs.title',
    },
  },
];
